module.exports = __webpack_public_path__ + "static/media/better-job-fit-neeta.3a961199.jpg";